/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { filteredURL } from '../Utilities/plp-url-utils';

export class GetSeoDataInput extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {

    private seoDataUrl: string = '';
    constructor(seoDataUrl: string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'SeoDataCache', cacheKey: 'SeoDataCache' });
        this.seoDataUrl = seoDataUrl;
    }

    public getSeoDataUrl = () => this.seoDataUrl;
    public getCacheKey = () => `SeoDataCache`;
    public getCacheObjectType = () => 'SeoDataCache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';

}

const createInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
    if (inputData.config && inputData.config.seoDataUrl) {
        return new GetSeoDataInput(inputData.config.seoDataUrl);
    }
    return new GetSeoDataInput('');
};

// tslint:disable: no-any
async function action(input: GetSeoDataInput, ctx: Msdyn365.IActionContext): Promise<any> {

    const jsonUrlFromGlobals = ctx.requestContext.app.config.seoDataUrl;
    // TODO: Just remove the fallback
    const jsonUrl = jsonUrlFromGlobals || 'https://files-us-prod.cms.commerce.dynamics.com/cms/api/fknscsckgq/binary/MA5cA7';
    const res = await Msdyn365.sendRequest<any>(jsonUrl, 'get');
    const filteredUrlPath = filteredURL(ctx.requestContext);
    const seoData = filteredUrlPath && res.data && res.data[filteredUrlPath];
    return seoData && seoData[0];
}

export default Msdyn365.createObservableDataAction({
    id: 'SeoDataCache',
    action: <Msdyn365.IAction<any>>action,
    input: createInput
});
